import { AutocompleteInput } from 'react-admin';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';

import { merchantCategoryCodeChoices } from '../../../constants/merchantCategoryCode';

const MerchantCategoryCode = () => (
  <Grid
    size={{
      xs: 12,
      sm: 6,
    }}
  >
    <Box display="flex" flexDirection="column">
      <Box display="flex" flexDirection="row" gap={2} alignItems="center">
        <Typography fontWeight="bold" color="black">Blocklisted Merchant Category Codes (MCC)</Typography>
      </Box>
      <Box display="flex" flexDirection="row" gap={2} alignItems="center" flexWrap="wrap">
        <AutocompleteInput
          fullWidth
          choices={merchantCategoryCodeChoices}
          source="ruleParameters.merchantCategoryCodes"
          multiple
          disabled
        />
      </Box>
    </Box>
  </Grid>
);

export default MerchantCategoryCode;
